export default "__VITE_ASSET__ca9f9a07__"